import { UPDATE_OPLOG, REFRESH_OPLOG } from "../types";

export function refreshOplog(oplog) {
  return {
    payload: oplog,
    type: REFRESH_OPLOG
  };
}

export default function(oplog) {
  return {
    payload: oplog,
    type: UPDATE_OPLOG
  };
}
